export const generateAvatarColor = (name: string): { bg: string; text: string } => {
    const colors: { bg: string; text: string }[] = [
        { bg: '#fecaca', text: '#991b1b' }, // red
        { bg: '#fef08a', text: '#854d0e' }, // yellow
        { bg: '#bbf7d0', text: '#166534' }, // green
        { bg: '#bfdbfe', text: '#1e40af' }, // blue
        { bg: '#c7d2fe', text: '#3730a3' }, // indigo
        { bg: '#e9d5ff', text: '#6b21a8' }, // purple
        { bg: '#fbcfe8', text: '#9f1239' }, // pink
        { bg: '#fed7aa', text: '#9a3412' }, // orange
        { bg: '#99f6e4', text: '#115e59' }, // teal
        { bg: '#a5f3fc', text: '#155e75' }, // cyan
        { bg: '#a7f3d0', text: '#065f46' }, // emerald
        { bg: '#bae6fd', text: '#075985' }, // sky
        { bg: '#ddd6fe', text: '#5b21b6' }, // violet
        { bg: '#f5d0fe', text: '#86198f' }, // fuchsia
        { bg: '#fecdd3', text: '#9f1239' }, // rose
        { bg: '#fde68a', text: '#92400e' }, // amber
        { bg: '#d9f99d', text: '#3f6212' }, // lime
        { bg: '#e7e5e4', text: '#44403c' }, // stone
    ];

    if (!name) return colors[0]!;

    let hash = 0;
    for (let i = 0; i < name.length; i++) {
        hash = name.charCodeAt(i) + ((hash << 5) - hash);
        hash = hash & hash; // Convert to 32bit integer
    }
    const index = Math.abs(hash % colors.length);
    return colors[index]!;
};

export const getInitials = (name: string) => {
    if (!name) return '';
    const trimmed = name.trim();
    if (trimmed.length <= 1) return trimmed.toUpperCase();

    const parts = trimmed.split(/\s+/);

    if (parts.length === 1) {
        return trimmed.slice(0, 1).toUpperCase();
    }

    const first = parts[0]?.[0] || '';
    const second = parts[1]?.[0] || '';

    return (first + second).toUpperCase();
};
